import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import type { EmptyProps } from '@change-corgi/core/types';

import { createStaticPageState, type StaticPageStateContext } from '../../StaticPageState';
import { createWindowPageState } from '../../WindowPageState';

import { PageStateProvider } from './context';

export const WindowPageStateProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const value = useMemo(() => createWindowPageState(), []);

	return <PageStateProvider value={value}>{children}</PageStateProvider>;
};

export const StaticPageStateProvider: React.FC<PropsWithChildren<{ context: StaticPageStateContext }>> = ({
	context,
	children,
}) => {
	const value = useMemo(() => createStaticPageState({ context }), [context]);

	return <PageStateProvider value={value}>{children}</PageStateProvider>;
};
